export function hasSessionHint(): boolean {
  return document.cookie.split('; ').some(c => c === 'logged_in=1');
}
